// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    addToEndOfChain,
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import setNotes from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";
import resetXCheckoutState from "@werner/App/Handlers/Checkout/ResetLocalState";

export const DispatchDataCleanup: any = (props: any) => {
    props.dispatch(setNotes({ notes: "" }));
    props.dispatch(resetXCheckoutState());
};

export const XngPopulateApiParameter: typeof PopulateApiParameter = (props: any) => {
    const state = props.getState();
    const xCheckoutState = state.xCheckout;
    const poNumber = xCheckoutState?.payment?.poNumber;
    const isPickup = props.apiParameter.cart.fulfillmentMethod === FulfillmentMethod.PickUp;
    props.apiParameter.cart = {
        ...props.apiParameter.cart,
        poNumber,
        notes:
            (isPickup ? xCheckoutState.shipping.pickupNotes : xCheckoutState.shipping.shippingNotes) ||
            props.apiParameter.cart.notes,
        properties: {
            ...props.apiParameter.cart.properties,
            attentionTo: xCheckoutState?.shipping.attentionTo || "",
            contactPhoneNumber: xCheckoutState.shipping.contactPhoneNumber || "",
            customerReleaseNumber: xCheckoutState?.payment.customerReleaseNumber || "",
            shippingMethod: xCheckoutState?.shipping.shippingMethod || "",
            OrderApprovalStatus: "Pending Approval",
            orderApprovalUpdatedStatus: "Pending Approval",
            ...(isPickup ? { pickUpDay: xCheckoutState?.shipping.pickupDay || "" } : {}),
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToEndOfChain(chain, DispatchDataCleanup);
